import { Injectable, Injector } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";

import { AuthService } from "../auth/auth.service";
import { switchMap } from "rxjs/operators";
import { from } from "rxjs";
import { ENV } from "@app/env";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // if a custom auth token is already set continue
    // if (req.headers.has("Authorization")) {
    //   return next.handle(req);
    // }
    const auth = this.injector.get(AuthService);
    // Get the auth token from the service.
    return from(auth.getAuthorizationToken()).pipe(
      switchMap((token) => {
        // Clone the request and replace the original headers with
        // cloned headers, updated with the authorization.
        let headers = req.headers.set("Authorization", `${token}`);
        headers = headers.set('Appversion', ENV.appversion);
        const authReq = req.clone({
          headers
        });
        // send cloned request with header to the next handler.
        return next.handle(authReq);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-interceptors/auth-interceptor.ts